import { render, staticRenderFns } from "./FireWorkPermit.vue?vue&type=template&id=58b0fdae"
import script from "./FireWorkPermit.vue?vue&type=script&lang=js"
export * from "./FireWorkPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports